import React from 'react'

import { VirtuosoTableRowProps } from './virtuoso-table-sections'

const VirutosoTableRow = <T,>({
  style,
  ...props
}: VirtuosoTableRowProps<T>): React.ReactElement => {
  return (
    <tr
      style={{
        ...style,
      }}
      {...props}
    ></tr>
  )
}

export default VirutosoTableRow
